import { Link } from "react-router-dom";
import "./Footer.css";
import {
  FaFacebookF,
  FaXTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
  FaPhone,
  FaEnvelope,
  FaLocationDot,
  FaChevronRight,
  FaGlobe,
} from "react-icons/fa6";
import { useHomeContext } from "../../context/Home_context";
import DOMPurify from "dompurify";

const Footer = () => {
  const { current_contact_data } = useHomeContext();

  return (
    <footer className="bb-footer">
      {/* ---------------TRICOLOR TOP LINE ---------------- */}
      <div className="tricolor-top-bar" />
      {/* ---------------- MAIN FOOTER CONTAINER ---------------- */}
      <div className="bb-footer-container">
        <div className="bb-footer-grid">
          {/* COLUMN 1: LOGO, BRAND STORY & SOCIAL */}
          <div className="bb-footer-col col-brand">
            <Link
              to="/"
              className="bb-logo-wrapper"
              aria-label="Bharat Buildcon Home"
            >
              {current_contact_data?.contact_banner_full_path && (
                <img
                  src={current_contact_data.contact_banner_full_path}
                  alt="Bharat Buildcon Logo"
                  className="bb-logo-img"
                  draggable="false"
                  onContextMenu={(e) => e.preventDefault()}
                />
              )}
            </Link>

            {current_contact_data?.contact_detail && (
              <div
                className="bb-brand-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(current_contact_data.contact_detail),
                }}
              />
            )}

            {(current_contact_data?.fb_link ||
              current_contact_data?.twitter_link ||
              current_contact_data?.youtube_link ||
              current_contact_data?.linkdin_link ||
              current_contact_data?.insta_link) && (
              <div className="bb-social-wrapper">
                <span className="bb-social-label">Follow Official Handles</span>
                <div className="bb-social-row">
                  {current_contact_data?.fb_link && (
                    <a
                      href={current_contact_data.fb_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bb-social-icon fb"
                      aria-label="Facebook"
                      title="Facebook"
                    >
                      <FaFacebookF />
                    </a>
                  )}
                  {current_contact_data?.twitter_link && (
                    <a
                      href={current_contact_data.twitter_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bb-social-icon tw"
                      aria-label="Twitter X"
                      title="Twitter X"
                    >
                      <FaXTwitter />
                    </a>
                  )}
                  {current_contact_data?.youtube_link && (
                    <a
                      href={current_contact_data.youtube_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bb-social-icon yt"
                      aria-label="YouTube"
                      title="YouTube"
                    >
                      <FaYoutube />
                    </a>
                  )}
                  {current_contact_data?.linkdin_link && (
                    <a
                      href={current_contact_data.linkdin_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bb-social-icon in"
                      aria-label="LinkedIn"
                      title="LinkedIn"
                    >
                      <FaLinkedinIn />
                    </a>
                  )}
                  {current_contact_data?.insta_link && (
                    <a
                      href={current_contact_data.insta_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bb-social-icon ig"
                      aria-label="Instagram"
                      title="Instagram"
                    >
                      <FaInstagram />
                    </a>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* COLUMN 2: DOMESTIC & INTERNATIONAL INQUIRY */}
          {(current_contact_data?.domestic_mobile1 ||
            current_contact_data?.domestic_mobile2 ||
            current_contact_data?.domestic_email ||
            current_contact_data?.inquiry_mobile ||
            current_contact_data?.inquiry_email) && (
            <div className="bb-footer-col col-inquiry">
              <h4 className="bb-col-heading">Contact &amp; Inquiries</h4>

              {/* Domestic Block */}
              {(current_contact_data?.domestic_mobile1 ||
                current_contact_data?.domestic_mobile2 ||
                current_contact_data?.domestic_email) && (
                <div className="inquiry-info-block">
                  <div className="inquiry-card-badge domestic-badge">
                    <FaPhone className="badge-icon" /> Domestic Inquiry
                  </div>
                  <ul className="inquiry-list">
                    {current_contact_data?.domestic_mobile1 && (
                      <li>
                        <a
                          href={`tel:${String(current_contact_data.domestic_mobile1).replace(/\s+/g, "")}`}
                        >
                          <span className="inq-icon-wrap">
                            <FaPhone />
                          </span>
                          <span className="notranslate" translate="no">
                            {current_contact_data.domestic_mobile1}
                          </span>
                        </a>
                      </li>
                    )}
                    {current_contact_data?.domestic_mobile2 && (
                      <li>
                        <a
                          href={`tel:${String(current_contact_data.domestic_mobile2).replace(/\s+/g, "")}`}
                        >
                          <span className="inq-icon-wrap">
                            <FaPhone />
                          </span>
                          <span className="notranslate" translate="no">
                            {current_contact_data.domestic_mobile2}
                          </span>
                        </a>
                      </li>
                    )}
                    {current_contact_data?.domestic_email && (
                      <li>
                        <a
                          href={`mailto:${current_contact_data.domestic_email}`}
                          className="email-link"
                        >
                          <span className="inq-icon-wrap email-wrap">
                            <FaEnvelope />
                          </span>
                          {current_contact_data.domestic_email}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              )}

              {/* International Block */}
              {(current_contact_data?.inquiry_mobile ||
                current_contact_data?.inquiry_email) && (
                <div className="inquiry-info-block space-top">
                  <div className="inquiry-card-badge intl-badge">
                    <FaGlobe className="badge-icon" /> International Inquiry
                  </div>
                  <ul className="inquiry-list">
                    {current_contact_data?.inquiry_mobile && (
                      <li>
                        <a
                          href={`tel:${String(current_contact_data.inquiry_mobile).replace(/\s+/g, "")}`}
                        >
                          <span className="inq-icon-wrap">
                            <FaPhone />
                          </span>
                          <span className="notranslate" translate="no">
                            {current_contact_data.inquiry_mobile}
                          </span>
                        </a>
                      </li>
                    )}
                    {current_contact_data?.inquiry_email && (
                      <li>
                        <a href={`mailto:${current_contact_data.inquiry_email}`} className="email-link">
                          <span className="inq-icon-wrap email-wrap">
                            <FaEnvelope />
                          </span>
                          {current_contact_data.inquiry_email}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          )}

          {/* COLUMN 3: EXPLORE LINKS */}
          <div className="bb-footer-col col-explore">
            <h4 className="bb-col-heading">Quick Navigation</h4>
            <ul className="bb-links-list">
              <li>
                <Link to="/aboutus">
                  <FaChevronRight className="link-arrow" /> About Us
                </Link>
              </li>
              <li>
                <Link to="/exhibition">
                  <FaChevronRight className="link-arrow" /> Exhibition
                </Link>
              </li>
              <li>
                <Link to="/gallery">
                  <FaChevronRight className="link-arrow" />
                  Media &amp; Gallery
                </Link>
              </li>
              <li>
                <Link to="">
                  <FaChevronRight className="link-arrow" /> About India
                </Link>
              </li>
              <li>
                <Link to="/contactus">
                  <FaChevronRight className="link-arrow" /> Contact Us
                </Link>
              </li>
              <li>
                <Link to="">
                  <FaChevronRight className="link-arrow" /> Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="">
                  <FaChevronRight className="link-arrow" /> Terms &amp;
                  Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* COLUMN 4: VENUE & HEAD OFFICE ADDRESS */}
          {current_contact_data?.head_contact_detail && (
            <div className="bb-footer-col col-address">
              <h4 className="bb-col-heading">Head Office</h4>
              <div className="address-info-block">
                <div className="address-header">
                  <div className="address-pin-icon">
                    <FaLocationDot />
                  </div>
                  <div
                    className="address-body"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        current_contact_data.head_contact_detail
                      ),
                    }}
                  />
                </div>

                {current_contact_data?.venue_link && (
                  <a
                    href={current_contact_data.venue_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="maps-direction-btn"
                  >
                    <FaLocationDot /> Get Directions
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ---------------- SLEEK BOTTOM BAR ---------------- */}
      <div className="bb-bottom-bar">
        <div className="bb-bottom-container">
          <div className="bb-copyright">
            Copyright
            <span className="notranslate" translate="no">
              {new Date().getFullYear()}
            </span>
            <strong>Bharat Buildcon</strong>. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
